// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"345":"be766ac6","485":"b5f29ee1","562":"b5f29ee1","580":"21e88bcd"}[chunkId] + ".chunk.css";
};